import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import { ConfirmDialogService } from 'src/app/service/confirm-dialog/confirm-dialog.service';
import { PageMoveService } from 'src/app/service/page-move.service';

@Component({
  selector: 'app-admin-notice',
  templateUrl: './admin-notice.component.html',
  styleUrls: ['./admin-notice.component.css']
})
export class AdminNoticeComponent implements OnInit {

  notices:Array<any>=[];
  selectedFlag:boolean=false;

  pages:Array<any>=[];
  currentPage:number = 0;
  maxPage:number = 0;

  constructor(
    private pageMove:PageMoveService,
    private apiService:ApiService,
    private confirmDialogService:ConfirmDialogService
  ) { }

  ngOnInit(): void {
    this.apiService.getNoticeData()
    .then((resp:any) =>{

      this.notices = resp;
      
      if(this.notices.length){
        this.notices.map((notice)=>{
          notice.selected = false;
        });
        
        this.maxPage  = Math.floor((this.notices.length-1)/10+1);

        this.pages = Array.from({length: this.maxPage},()=> { return {selected: false}} );
        this.pages[0].selected = true;
      }
    })
    .catch((err)=>{
      console.log(err);
    })
  }


  nextPage(){
    if(this.currentPage<this.maxPage-1){
      this.pages[this.currentPage].selected=false;
      this.currentPage++;
      this.pages[this.currentPage].selected=true;

      this.unselectedAll();
    }
  }
  prevPage(){
    if(this.currentPage > 0){
      this.pages[this.currentPage].selected=false;
      this.currentPage--;
      this.pages[this.currentPage].selected=true;

      this.unselectedAll();
    }
  }

  selectNumber(page:any,pageNum:number){
    this.pages.map((page)=>page.selected=false);

    page.selected = true;
    this.currentPage = pageNum;

    this.unselectedAll();
  }
  selectedAll(){
    if(this.selectedFlag){
      if(this.notices.length >=this.currentPage*10+10){
        for(let i = this.currentPage*10; i< this.currentPage*10+10;i++){
          this.notices[i].selected = false;
        }
      }
      else{
        for(let i = this.currentPage*10; i < this.notices.length; i++ ){
          this.notices[i].selected = false;
        }
      }
      this.selectedFlag = false;
    }
    else{
      if(this.notices.length >=this.currentPage*10+10){
        for(let i = this.currentPage*10; i< this.currentPage*10+10;i++){
          this.notices[i].selected = true;
        }
      }
      else{
        for(let i = this.currentPage*10; i < this.notices.length; i++ ){
          this.notices[i].selected = true;
        }
      }
      this.selectedFlag = true;
    }
  }

  edit(notice:any){
    this.pageMove.goNoticeEdit(notice);
  }
  
  checked(notice:any){
    notice.selected = !notice.selected;
  }

  delete(){
    this.confirmDialogService.confirm('선택한 항목을 삭제하시겠습니까?')
    .then((confirm) =>{
      if(confirm){
        let ids:Array<string>= this.getSelectedIds();

        this.apiService.removeNoticeData(ids)
        .then(()=>{this.pageReload(); })
        .catch((err)=>{
          console.log(err);
        })
      }
    })
  }


  getSelectedIds():Array<string>{
    let ids:Array<string>= [];

    this.notices.map((notice)=>{
      if(notice.selected){
        ids.push(notice.id);
      }
    })

    return ids;
  }

  pageReload(){
    this.notices = this.notices.filter((notice)=>{
      if(!notice.selected)
        return notice;
    })

    this.maxPage  = Math.floor((this.notices.length-1)/10+1);
    
    if(this.notices.length){
      this.pages = Array.from({length: this.maxPage},()=> { return {selected: false}} );
      this.pages[0].selected = true;
    }
    this.selectedFlag = false;
  }

  unselectedAll(){
    this.notices.map((notice)=>{
      notice.selected = false;
    })
    this.selectedFlag = false;
  }
}
